import { LocalizedTypography, SpacedForwardSlash } from '@mews-commander/ui';
import { Optional } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { Container, Icon, IconName, IconVariant, Stack, Typography } from '@optimus-web/core';

interface Props {
    absolutePerTimeUnitLimit: Optional<number>;
    disabled: boolean;
    sold: number;
    usableResources: Optional<number>;
}

export const SellLimitCell = ({ absolutePerTimeUnitLimit, disabled, sold, usableResources }: Props) => {
    let iconVariant: IconVariant = 'basic';

    const hasLimitReached = absolutePerTimeUnitLimit != null ? sold === absolutePerTimeUnitLimit : false;
    const hasLimitExceeded = absolutePerTimeUnitLimit != null ? sold > absolutePerTimeUnitLimit : false;
    const isCellInative = absolutePerTimeUnitLimit == null && usableResources != null && sold >= usableResources;

    const displayIcon = hasLimitReached || hasLimitExceeded || isCellInative || disabled;

    if (hasLimitReached && !disabled) {
        iconVariant = 'warning';
    } else if (hasLimitExceeded && !disabled) {
        iconVariant = 'danger';
    }

    return (
        <Container padding={['50', '0']}>
            <Stack vertical spacing="100">
                <Stack vertical itemAlignment="end" spacing="50">
                    <Stack fill={displayIcon} distribution="space-between" itemAlignment="center">
                        {displayIcon ? (
                            <Icon
                                value={hasLimitExceeded ? IconName.Disable : IconName.Problematic}
                                size="small"
                                variant={iconVariant}
                            />
                        ) : null}
                        <Typography textStyle="bodyMedium" as="div">
                            {absolutePerTimeUnitLimit != null ? (
                                <>
                                    <span data-test-id="sold">{sold}</span>
                                    {SpacedForwardSlash}
                                    <span data-test-id="sell-limit">{absolutePerTimeUnitLimit}</span>
                                </>
                            ) : (
                                <span data-test-id="sold">{sold}</span>
                            )}
                        </Typography>
                    </Stack>
                    <LocalizedTypography
                        textStyle="bodyExtraSmall"
                        textKey={TextKey.SellLimitsSoldSpacesLabel}
                        as="div"
                    />
                </Stack>
            </Stack>
        </Container>
    );
};
